import React from "react";

const LoadingSkeleton: React.FC = () => {
  return (
    <div className="flex-1 overflow-auto pb-16">
      <div className="flex justify-center items-center w-full py-8">
        <div className="animate-pulse bg-gray-200 rounded-xl h-48 w-80"></div>
      </div>

      <div className="px-4 mt-4">
        <div className="h-8 w-32 bg-gray-200 animate-pulse rounded mb-4"></div>
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="animate-pulse bg-gray-200 rounded-xl h-32 w-full"
            ></div>
          ))}
        </div>
      </div>

      <div className="px-4 mt-8">
        <div className="h-8 w-32 bg-gray-200 animate-pulse rounded mb-4"></div>
        <div className="h-10 bg-gray-200 animate-pulse rounded-t mb-4"></div>
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="animate-pulse bg-gray-200 rounded-xl h-32 w-full"
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
